import { TranslateFn } from '~/shared/utils/translation/hooks/useTranslation';

export const createLoyaltyMutation = async (
    endpoint: string,
    translate: TranslateFn,
    trackError: (error: unknown) => void,
    payload: { memberId?: string; rewardCode: string },
) => {
    if (!payload.memberId || !payload.rewardCode) {
        throw new Error('Missing payload');
    }

    const res = await fetch(`/api/loyalty/${endpoint}`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const error = new Error(translate('basket.couldNotSaveChangesError'));
        trackError(error);
        throw error;
    }

    return res.json();
};
